type UserSessionType = {
    clientId: string;
    clientLogo: string;
    isClient: boolean;
    clientName: string;
    roleType: string;
    subClientId: string;
}

type UseGetUserSessionReturn = {
    session: UserSessionType | null;
};

const safeParse = (value: string | null) => {
    if (!value) return null;
    try {
        return JSON.parse(value);
    } catch {
        return null;
    }
};

export function useGetUserSession(
): UseGetUserSessionReturn {
    const parsedUserData = safeParse(localStorage.getItem('user'));
    const selectedClient = safeParse(
        sessionStorage.getItem('currentSelectedClient'),
    );

    const session = {
        clientId: selectedClient?.clientId ?? parsedUserData?.clientId,
        clientLogo: selectedClient?.clientLogo ?? parsedUserData?.clientLogo,
        isClient: selectedClient?.isClient ?? parsedUserData?.isClient,
        clientName: selectedClient?.clientName ?? parsedUserData?.clientName,
        roleType: selectedClient?.role ?? parsedUserData?.userType,
        subClientId: selectedClient?.clientId ?? parsedUserData?.clientId
    };

    return { session };
}